export class UpdateMetricExportDestinationInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "otlpEndpoint",
            "baseName": "otlpEndpoint",
            "type": "string",
            "format": "uri"
        },
        {
            "name": "otlpProtocol",
            "baseName": "otlpProtocol",
            "type": "TelemetryExportOtlpProtocol",
            "format": ""
        },
        {
            "name": "authMode",
            "baseName": "authMode",
            "type": "TelemetryExportAuthMode",
            "format": ""
        },
        {
            "name": "secretRef",
            "baseName": "secretRef",
            "type": "UpdateMetricExportDestinationInputSecretRef",
            "format": ""
        },
        {
            "name": "basicAuthUsername",
            "baseName": "basicAuthUsername",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateMetricExportDestinationInput.attributeTypeMap;
    }
    constructor() {
    }
}
